import Vue from 'vue'
import pluginValue from './nice'
const pluginName = '$niceApi'

const plugin = {
  install(Vue) {
    window[pluginName] = pluginValue
    Vue.prototype[pluginName] = pluginValue
  },
}

Vue.use(plugin)

export default plugin

export const niceApi = pluginValue
